import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'team-video';
@Injectable({
    providedIn: 'root'
})
export class TeamVideoService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getTeamVideoList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }
    getTeamVideoListWithoutAuth(query): Observable<any> {
        return this.http.get(API_URL + '/v1' + query);
    }
    getTeamVideoDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id);
    }
    getTeamVideoDetailsWithoutAuth(id): Observable<any> {
        return this.http.get(API_URL + '/v1/' + id);
    }
    updateTeamVideo(id, data): Observable<any> {
        return this.http.put(API_URL + '/' + id, data);
    }
    addTeamVideo(data): Observable<any> {
        return this.http.post(API_URL, data);
    }
}